import styled from "styled-components";
import { Color, Font, breakpoints, ColorDark } from "@/shared/Constants";

export const FlipContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  transform: rotateY(-180deg);
  display: ${(props) => (props.isOpen ? "flex" : "none")};
  ${(props) =>
    props.isOpen ? "animation: show 0.5s forwards;" : "animation: hide 0.5s forwards;"}
  z-index:9999;
      background-color: ${Color.greyF5F5F5};

  @keyframes show {
    0% {
      opacity: 0;
      display: none;
    }
    43% {
      opacity: 0;
      display: none;
    }
    44% {
      opacity: 0.95;
      display: flex;
    }

    100% {
      opacity: 0.95;
      display: flex;
    }
  }
  @keyframes hide {
    0% {
      opacity: 0.95;
      display: flex;
    }
    50% {
      opacity: 0.95;
      display: flex;
    }
    61% {
      opacity: 0;
      display: none;
    }

    100% {
      opacity: 0;
      display: none;
    }
  }
`;

export const BorderColor = styled.hr`
  border: 1px solid ${Color.grey707070};
  width: 100%;
`;

export const ContainerListCollection = styled.div`
  min-height: 170px;
  height: 170px;
  overflow: hidden;
`;

export const ListCollection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin: 0.5rem;
  margin-bottom: 0.75rem;
  padding: 0 1rem;
  input[type="radio"] {
    margin: 0;
    width: 22px;
    height: 22px;
    display: block;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-color: white;
    border: 1px solid ${Color.grey} !important; /* Borde gris */
    border-radius: 0;
    cursor: pointer;
    position: relative;

    &::before {
      content: "";
      width: 13px; /* Tamaño del cuadrado interno */
      height: 13px;
      background-color: ${Color.mainColor};
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: none; /* Oculto por defecto */
    }

    &:checked {
      border-color: ${Color.grey};
      background-color: white; /* Mantiene el fondo blanco */
      &::before {
        display: block; /* Muestra el cuadrado rojo */
      }
    }
  }

  label {
    ${Font.sansLight};
    font-size: 16px;
    text-transform: lowercase !important;
    text-align: left;
    &::first-letter {
      text-transform: uppercase;
    }
  }
`;

export const AddNameCollection = styled.div`
  padding: 1rem 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  label {
    ${Font.clarinVarSub2Regular}
  }
  input {
    width: 100%;
    height: 44px;
    border-radius: 4px;
    text-align: center;
  }
`;

export const FoodCardAdd = styled.div`
  max-width: 310px;
  width: 100%;
  max-height: 480px;
  padding: 1rem;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  ${breakpoints.phone}{
    max-width: 100%;
    width: 100%;
  }
  .titleCard {
    ${Font.sansRegular};
    letter-spacing: 0px;
    color: ${Color.grey};
    text-transform: uppercase;
    font-size: 12px;
    line-height: 26px;
    &.m-right-auto {
      margin-right: auto !important;
    }
  }
  form {
    width: 100%;
  }
`;
export const FoodNewCollection = styled.div`
  display: none;
  top: -100%;
  width: 100%;
  max-height: 480px !important;
  ${breakpoints.phone}{
    max-width: 100%;
    width: 100%;
    max-height: 100%;
  }
  &.isOpen {
    display: flex;
    flex-direction: column;
    position: absolute;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100%;
    z-index: 10;
    background: ${Color.greyF5F5F5} 0% 0% no-repeat padding-box;
    opacity: 0.95;
    transition: ease-in-out 3ms;
  }
  .titleCard {
    ${Font.sansRegular};
    letter-spacing: 0px;
    color: ${Color.grey};
    text-transform: uppercase;
    font-size: 12px;
    line-height: 26px;
    &.m-right-auto {
      margin-right: auto !important;
    }
  }
  form {
    width: 100%;
  }
`;

export const FoodCardRemove = styled.div`
  display: none;
  max-width: 310px;
  max-height: 480px;
  ${breakpoints.phone}{
    max-width: 100%;
    max-height: 100%;
  }
  &.isOpen {
    display: flex;
    flex-direction: column;
    display: flex;
    position: absolute;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
    background: ${Color.greyF5F5F5} 0% 0% no-repeat padding-box;
    opacity: 0.95;
    transition: ease-in-out 3ms;
  }
  .titleCard-delete {
    ${Font.sansRegular};
    letter-spacing: 0px;
    color: ${Color.grey};
    font-size: 20px;
    line-height: 26px;
    text-align: center;
    margin-bottom: 1rem;
  }
  form {
    width: 100%;
  }
`;

export const FoodCardSaved = styled.div`
  display: none;
  max-width: 310px;
  max-height: 480px;
  ${breakpoints.phone}{
    max-width: 100%;
    max-height: 100%;
  }
  &.isOpen {
    display: flex;
    flex-direction: column;
    display: flex;
    position: absolute;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
    background: ${Color.greyF5F5F5} 0% 0% no-repeat padding-box;
    opacity: 0.95;
    transition: ease-in-out 3ms;
    transform: rotateY(-180deg);
  }
  .titleCard-message{
    ${Font.sansRegular};
    letter-spacing: 0px;
    color: ${Color.grey};
    font-size: 20px;
    line-height: 26px;
    text-align: center;
    margin-bottom: 1rem;
  }
  form {
    width: 100%;
  }
  button {
      all: unset;
      position: absolute;
      top: 0;
      right: 0;
      cursor: pointer;
      margin: 18px;
    }
`;

export const SaveExit = styled.div`
  position: absolute;
  top: 0;
`;

export const BtnCollection = styled.div`
  display: flex !important;
  flex-wrap: nowrap;
  gap: 0.5rem;
  align-items: center;
  padding: 0.5rem 1rem;
  width: max-content;
  cursor: pointer;
  border-radius: 4px;
  color: ${Color.grey};
  ${Font.clarinVarSub2Bold};
  z-index: 1;
  &.btnCircle {
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    /* border: 1px solid ${Color.grey}; */
    /* background-color: ${Color.white}; */
    overflow: hidden;
    /*  .btn-deleted {
          color: ${Color.grey};
        } */
    &:hover {
      background-color: ${Color.grey};
      color: ${Color.white};
    }
  }
  &:hover {
    background-color: ${Color.lightGrey};
    color: ${Color.linkColor};
  }
`;

export const BtnGroupPagination = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  .textPagination {
    text-transform: uppercase;
    color: ${Color.grey};
    font-size: 11px;
    line-height: 26px;
    ${Font.sansRegular};
  }
  .btnPrev,
  .btnNext {
    all: unset;
    position: absolute;
    top: calc(50% - 21px);
    transform: translateY(-50%);
    width: 21px;
    height: 21px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${Color.grey};
  }
  .btnPrev {
    left: 0.75rem;
  }
  .btnNext {
    right: 0.75rem;
  }
`;
